import type {EntityCardAction, EntityCardActionContext, RegisteredEntityCardAction, RegisteredEntityCardActionSpec} from './entity-card-action.types';
import {createRegistry} from '@Components/ai-chat-window/lib/create-registry';
import {eventEntityCardAction} from './event.action';
import {pdfEntityCardAction} from './pdf.action';

/**
 * Fuse a typed action's parsePayload + onClick into one payload-erased `run`, closing over
 * TPayload so a wrong parsePayload/onClick pairing is caught here at registration — no cast.
 */
function defineEntityCardAction<TPayload>(action: EntityCardAction<TPayload>): RegisteredEntityCardAction {
  const cardActions = (action.cardActions ?? []).map((spec): RegisteredEntityCardActionSpec => {
    return {
      icon: spec.icon,
      ariaLabelKey: spec.ariaLabelKey,
      isSelected: spec.isSelected,
      run: (raw: Record<string, unknown>, ctx: EntityCardActionContext) => spec.run(action.parsePayload(raw), ctx),
    };
  });

  return {
    entityType: action.entityType,
    cardActions,
    run: (raw, ctx) => action.onClick(action.parsePayload(raw), ctx),
  };
}

const REGISTRY = createRegistry(
  [defineEntityCardAction(eventEntityCardAction), defineEntityCardAction(pdfEntityCardAction)],
  (action) => action.entityType,
);

export const getEntityCardAction = (entityType: string | undefined): RegisteredEntityCardAction | undefined => {
  if (entityType === undefined) {
    return undefined;
  }
  return REGISTRY[entityType];
};
